import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: "root"})
export class Lk2Resource {

  http = inject(HttpClient);

  public getConsentLk2() {
    let redirectUri = window.location.href;
    redirectUri = btoa(redirectUri);
    return this.http.get(`/api/lk2/consent-lk2?redirectUri=${redirectUri}`, { responseType: 'text' });
  }
}
